module.exports = fox._r("images/halloween/gift-141.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/halloween/gift-141.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/halloween/gift-141.png
// module id = 342
// module chunks = 4